import { Component, Input } from '@angular/core';
import { MilestoneEntryComponent } from '../milestone-entry/milestone-entry.component';
import { MilestoneUtil } from '../../../MilestoneUtil';
import { DateUtil } from '../../../DateUtil';

@Component({
  selector: 'digires-construction-milestone-entry',
  templateUrl: './construction-milestone-entry.component.html',
  styleUrls: ['./construction-milestone-entry.component.scss'],
})
export class ConstructionMilestoneEntryComponent extends MilestoneEntryComponent {
  @Input() canEditFid: boolean;

  getFidDatePlaceholder(): string {
    if (this.data.ms.constructionTemplate.isSingleMilestone) {
      return '@FID - Date';
    } else {
      return '@FID - End Date';
    }
  }

  getDatePlaceholder(): string {
    if (this.data.ms.constructionTemplate.isSingleMilestone) {
      return 'Current - Date';
    } else {
      return 'Current - End Date';
    }
  }

  isStartDateInPast(): boolean {
    const fgValue = this.data.fg.getRawValue();
    return MilestoneUtil.isIncompleteInPast({
      date: DateUtil.anyToDate(fgValue.dateStart),
      done: fgValue.started,
      na: fgValue.notApplicable,
    });
  }

  isStartDateInFuture(): boolean {
    const fgValue = this.data.fg.getRawValue();
    return MilestoneUtil.isCompleteInFuture({
      date: DateUtil.anyToDate(fgValue.dateStart),
      done: fgValue.started,
      na: fgValue.notApplicable,
    });
  }

  isEndDateInPast(): boolean {
    const fgValue = this.data.fg.getRawValue();
    return MilestoneUtil.isIncompleteInPast({
      date: DateUtil.anyToDate(fgValue.date),
      done: fgValue.complete,
      na: fgValue.notApplicable,
    });
  }

  isEndDateInFuture(): boolean {
    const fgValue = this.data.fg.getRawValue();
    return MilestoneUtil.isCompleteInFuture({
      date: DateUtil.anyToDate(fgValue.date),
      done: fgValue.complete,
      na: fgValue.notApplicable,
    });
  }

  hasErrorAt(formCtrl: string, errorId: string): boolean {
    return this.data.fg.get(formCtrl).hasError(errorId);
  }

  onCompleteChanged() {
    const value = this.data.fg.getRawValue();
    if (value.complete) {
      this.data.fg.patchValue({
        started: true,
      });
    }
  }
}
